<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>You Can’t Tell by Looking</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Russell J. Sanders</p>
<p class="P_Normal"> </p>
<p class="P_Normal">When Gabe Dillon starts the year at a new school, one young man captures and holds all his attention. Kerem Uzun is the senior class president. He’s friendly, popular, the son of doctors, of Turkish descent, and Muslim.</p>
<p class="P_Normal">Soon Gabe’s curiosity about Kerem extends to Kerem’s religious practices. He’s fascinated by the culture, philosophy, and rituals of Islam, but one thing worries him: many practitioners of the religion are outraged by proud gay men like Gabe. Kerem’s cousin Timur, an orphan who was raised alongside Kerem as a brother, is one of them. And he isn’t the only one standing in the way of their budding relationship.</p>
<p class="P_Normal">Gabe knows he can’t choose who he falls in love with, and he could fall for Kerem. But is Kerem even attracted to men? Will he go against his fundamentalist cousin for a chance to be with Gabe? With so many forces trying hard to tear it down, building a romance will mean a struggle.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?45369325